import { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "@/data/siteContent";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const per = 1; // main card
  const total = testimonials.length;

  const next = () => setIdx((i) => (i + 1) % total);
  const prev = () => setIdx((i) => (i - 1 + total) % total);

  const active = testimonials[idx];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section relative"
    >
      <div className="container-luxe">
        <div className="reveal flex items-end justify-between gap-6 flex-wrap">
          <div>
            <div className="text-[11px] tracking-[0.4em] uppercase text-gold-light">
              Testimonials · अनुभव
            </div>
            <h2
              data-testid="testimonials-title"
              className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05] text-cream"
            >
              Voices of{" "}
              <span className="italic font-editorial gold-text">
                seekers
              </span>
              .
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              data-testid="testimonial-prev"
              onClick={prev}
              className="w-11 h-11 rounded-full gold-border grid place-items-center text-gold hover:bg-[#D4AF37]/10 transition-colors"
              aria-label="Previous testimonial"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              data-testid="testimonial-next"
              onClick={next}
              className="w-11 h-11 rounded-full gold-border grid place-items-center text-gold hover:bg-[#D4AF37]/10 transition-colors"
              aria-label="Next testimonial"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="mt-14 grid lg:grid-cols-[1.1fr_0.9fr] gap-6">
          {/* Featured */}
          <div
            key={active.name}
            data-testid="testimonial-featured"
            className="reveal glass-strong rounded-3xl p-10 sm:p-14 relative overflow-hidden"
          >
            <Quote
              className="absolute -top-6 -left-6 w-40 h-40 text-[#D4AF37]/10"
              strokeWidth={0.6}
            />
            <div className="relative">
              <div className="flex gap-1 text-gold">
                {Array.from({ length: active.stars }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#D4AF37]" />
                ))}
              </div>
              <blockquote className="mt-6 font-editorial italic text-2xl sm:text-3xl leading-snug text-cream">
                “{active.quote}”
              </blockquote>
              <div className="mt-10 flex items-center gap-4">
                <div className="w-12 h-12 rounded-full gold-border grid place-items-center font-display text-gold">
                  {active.name
                    .split(" ")
                    .map((p) => p[0])
                    .join("")
                    .slice(0, 2)}
                </div>
                <div>
                  <div className="font-display text-cream">{active.name}</div>
                  <div className="text-[11px] tracking-[0.22em] uppercase text-cream-muted mt-1">
                    {active.location}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Grid of others */}
          <div className="grid sm:grid-cols-2 gap-4">
            {testimonials
              .filter((_, i) => i !== idx)
              .slice(0, 4)
              .map((t) => (
                <div
                  key={t.name}
                  data-testid={`testimonial-mini-${t.name}`}
                  className="reveal glass rounded-2xl p-6"
                >
                  <div className="flex gap-1 text-gold">
                    {Array.from({ length: t.stars }).map((_, i) => (
                      <Star key={i} className="w-3.5 h-3.5 fill-[#D4AF37]" />
                    ))}
                  </div>
                  <p className="mt-4 text-[13.5px] text-cream-muted leading-relaxed line-clamp-4">
                    “{t.quote}”
                  </p>
                  <div className="mt-5 font-display text-sm text-cream">
                    {t.name}
                  </div>
                  <div className="text-[10.5px] tracking-[0.22em] uppercase text-cream-muted mt-1">
                    {t.location}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
